import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Modal from "react-modal";
import PerfectScrollbar from "react-perfect-scrollbar";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import RadioButtonUncheckedOutlinedIcon from "@material-ui/icons/RadioButtonUncheckedOutlined";
import AddIcon from "@material-ui/icons/Add";
import ActionButton from "../general/ActionButton";

import { Switch } from "@material-ui/core";
import {
  getDefaultInsurersList,
  getDefaultInsurersListSelector,
} from "../store/brokerage";
import {
  toggleAddInsurerModal,
  addInsurer,
  updateInsurer,
  getAddInsurerStatus,
  getSelectedInsurerDetails,
  getInsurerDetails,
  getInsurerOptions,
  getInsurerOptionsList,
} from "../store/insurers";
import { getVerticalList, loadverticals } from "../store/verticals";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { Redirect } from "react-router-dom";
import Select from "react-dropdown-select";
import { useNavigate, useSearchParams } from "react-router-dom";

const InsurerAdminAppetite = (props) => {
  return (
    <InsurerAdminAppetiteDashboardPane
      insurerCode={props.insurerCode}
    ></InsurerAdminAppetiteDashboardPane>
  );
};

const InsurerAdminAppetiteDashboardPane = (props) => {
  const [insurer, setInsurer] = useState(null);
  const dispatch = useDispatch();
  let [searchParams, setSearchParams] = useSearchParams();
  const queryCode = searchParams.get('c');
  let history = useNavigate();
  useEffect(() => {
    dispatch(getDefaultInsurersList());
  }, []);
  let insContacts = useSelector(getDefaultInsurersListSelector);

  // On operation selected
  const onChangeHandle = async (value) => {
    if (value[0]?.code) {
      setInsurer(null);
      await dispatch(getInsurerDetails(value[0].code));
      history(
        "/quoteyadmin/insurerappetite?c=" + encodeURIComponent(value[0].code)
      );
    }
  };

  if (insContacts && props.insurerCode && insurer == null) {
    for (let ic of insContacts) {
      if (ic.code == props.insurerCode) {
        setInsurer(ic);
      }
    }
    //if (insurer == null) setInsurer(insContacts[0]);
  } else if (insContacts && insContacts[0]?.code && !props.insurerCode) {
    //setInsurer(null);
    history(
      "/quoteyadmin/insurerappetite?c=" +
        encodeURIComponent(insContacts[0]?.code)
    );
  }

  console.log("Ramzilla insurer", insurer)
  console.log(queryCode)
  if(queryCode && insurer && insurer.code && insurer.code != queryCode){
    let insContact = insContacts.find(x => x.code == queryCode);
    console.log("insContact!!  ",insContact)
    setInsurer(insContact)
  }
  return (
    <div
      style={{
        margin: "3.5rem",
      }}
    >
      <div>
        {/* <h5 className="px-2" style={{
          fontFamily: "GibsonSemiBd",
          justifyContent: "center",
          fontSize: "1.2vw",
        }}>You can customize the e-mail contacts and names that your team sees for insurers when sending to market.</h5> */}
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingLeft: "5%",
            paddingRight: "5%",
          }}
        >
          {}

          <div
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <div style={{ width: "100%" }}>
              <Select
                placeholder={insurer ? insurer.name : "Search for an insurer"}
                color={theme.COLORS.primary_navyblue}
                searchable={true}
                onChange={(values) => onChangeHandle(values)}
                values={[]}
                options={insContacts}
                style={{
                  width: "100%",
                  height: "6vh",
                  fontSize: "1.9vmin",
                  border: "5px solid white",
                  borderRadius: 15,
                  fontFamily: "GibsonRegular",
                }}
                labelField={"name"}
                valueField={"code"}
                dropdownHeight={"58vh"}
              />
            </div>
          </div>
          <br />
        </div>
        <InsurerVerticalItems insurer={insurer} setInsurer={setInsurer} />
      </div>
    </div>
  );
};

const InsurerVerticalItems = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadverticals());
  }, []);
  let verticals = useSelector(getVerticalList);
  console.log("InsurerVerticalItems: ")
  const checkIfVerticalHasAppetite = (item) => {
    if (props.insurer && props.insurer.verticalids) {
      return props.insurer.verticalids.includes(item.id);
    } else return false;
  };
  return (
    <div
      className="m-4"
      style={{
        fontFamily: "GibsonRegular",
        fontSize: "0.8vw",
        justifyContent: "center",
      }}
    >
      <table className="table table-sm">
        <thead>
          <tr>
            <th scope="col">Vertical</th>
            <th scope="col">Appetite</th>
          </tr>
        </thead>
        <tbody>
          {verticals ? (
            verticals.map((item, index) => {
              return (
                <Fragment key={index}>
                  <tr scope="row" className="thead-light">
                    <th scope="row">{item.name["en"]}</th>
                    <th scope="row">
                      <Switch
                        checked={checkIfVerticalHasAppetite(item)}
                        color="primary"
                        onChange={() => {
                          let verts = [];
                          for (let v of props.insurer?.verticalids) {
                            verts.push(v);
                          }
                          if (!verts) verts = [item.id];
                          else {
                            if (verts.includes(item.id)) {
                              verts = [];
                              for (let v of props.insurer?.verticalids) {
                                if (item.id != v) verts.push(v);
                              }
                            } else verts.push(item.id);
                          }
                          let data = {
                            insurer: {
                              name: props.insurer?.name,
                              code: props.insurer?.code,
                              emails: props.insurer?.emails,
                              starrating: props.insurer?.starrating,
                              description: props.insurer?.description,
                              quotesby: props.insurer?.quotesby,
                              markettype: props.insurer?.markettype,
                              otherinfo: props.insurer?.otherinfo,
                              verticalids: verts,
                              bindtype: props.insurer?.bindtype,
                              verticalId: props.insurer?.verticalId,
                              insurer_is_type1:
                                typeof props.insurer?.insurer_is_type1 ==
                                "boolean"
                                  ? props.insurer?.insurer_is_type1
                                  : props.insurer?.markettype,
                            },
                          };
                          dispatch(updateInsurer(data))
                          .then(
                            setTimeout(() => {
                              //window.location.reload(false);
                              //dispatch(getDefaultInsurersList());
                              dispatch(props.setInsurer(data.insurer));
                              console.log("DISPATCHED")
                            }, 500)
                          );
                        }}
                      />
                    </th>
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InsurerAdminAppetite;
